export const BASE_PATH = 'https://admin.cecilvinegar.co.za'
// export const BASE_PATH = 'https://admin.cecilvinegar.stageoptimal.co.za'
// export const BASE_PATH = 'http://127.0.0.1:8000' 